import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

interface Props extends IconUIComponentProps {
  animated?: boolean;
}

export default function ({
  color,
  size,
  style,
  className,
  noFill,
  animated,
}: Props) {
  const styles = useIconStyle({ noFill });
  const classes = [styles.icon, className]
    .concat(animated ? 'animation-rotate' : '')
    .join(' ')
    .trim();
  return (
    <svg
      className={classes}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.41668 15.1875L14.6667 10.5L8.41668 5.81248V15.1875ZM10.5 0.083313C4.7448 0.083313 0.0833435 4.74477 0.0833435 10.5C0.0833435 16.2552 4.7448 20.9166 10.5 20.9166C16.2552 20.9166 20.9167 16.2552 20.9167 10.5C20.9167 4.74477 16.2552 0.083313 10.5 0.083313ZM10.5 18.8333C5.90626 18.8333 2.16668 15.0937 2.16668 10.5C2.16668 5.90623 5.90626 2.16665 10.5 2.16665C15.0938 2.16665 18.8333 5.90623 18.8333 10.5C18.8333 15.0937 15.0938 18.8333 10.5 18.8333Z"
      />
    </svg>
  );
}
